import classNames from 'classnames';
import React from 'react';

import styles from './index.less';

const PageNotFound = ({
  className = '',
  title = 'Oops!',
  description = 'This page is not available!',
}) => {
  const titleClasses = classNames('header-404', styles.title);
  const descClasses = classNames('description-404', styles.desc);

  return (
    <div className={classNames(styles.pageNotFound, className)}>
      {title && <h1 className={titleClasses}>{title}</h1>}
      {description && <p className={descClasses}>{description}</p>}
    </div>
  );
};

export default PageNotFound;
